import Axios, { type InternalAxiosRequestConfig } from "axios";
import { env } from "src/config/env";
import { StorageKeys } from "src/enums/StorageKeys.enum";
import { getStorageItem, removeStorageItem } from "src/lib/localStorage";

//* Attach auth headers to requests here
function authRequestInterceptor(config: InternalAxiosRequestConfig) {
	if (config.headers) {
		config.headers.Accept = "application/json";
	}

	//! This is for testing purposes
	config.headers["Access-Control-Allow-Origin"] = "*";
	config.headers["Access-Control-Allow-Methods"] = "GET, POST, PUT, DELETE, OPTIONS";

	//* Unauthenticated paths
	//! Please edit these as necessary
	const nonAuthPaths = ["/"];
	const currentApiPath = config.url ?? "";
	if (nonAuthPaths.includes(currentApiPath)) {
		return config;
	}

	//* Authenticated paths
	const jwt = getStorageItem(StorageKeys.token);
	if (jwt) {
		config.headers.Authorization = `Bearer ${jwt}`;
	}
	return config;
}

export const api = Axios.create({
	baseURL: env.API_BASE_URL + "/admin",
});

api.interceptors.request.use(authRequestInterceptor);
api.interceptors.response.use(
	(response) => {
		return response.data;
	},
	(error) => {
		console.error("api error.response", error.response);

		if (error.message === "Network Error") {
			return Promise.reject(error);
		}

		//* This is the redirect logic for production
		if (error.response?.status === 401) {
			removeStorageItem(StorageKeys.token);
			removeStorageItem(StorageKeys.name);
			removeStorageItem(StorageKeys.role);
			return Promise.reject({
				title: "Refresh required",
				message: "Please log out and back in to get access.",
			});
		}

		if (error.response?.status === 500) {
			return Promise.reject({
				status: 500,
				message: "Something went wrong...",
				data: error.response?.data,
			});
		}

		if (typeof error.response.data?.error === "string") {
			return Promise.reject({
				status: error.response.status,
				message: error.response.data.error,
				data: error.response.data,
			});
		}

		return Promise.reject({
			status: error.response?.status,
			message: "Something went wrong...",
			data: error.response?.data,
		});
	},
);
